import React from 'react';
import {Flex, Title, flexWrapProps, Text} from '@priority-software/priority-style-react';
import {ChatBoxButton} from '../../../../../components/Common/Chatbox/ChatBox';
import styles from '../../../styles.module.scss';
import {ChartIcons} from '../../../chartConsts';
import {PanelBlock} from '../../../../../components/Common/PanelBlock/PanelBlock';
import {getChartLabelByType, getChartTooltipByType} from '../../../utils';

const ChartTypesCard = ({title, chartTypeList, currentType, handleChartButtonClick}) => {
    return (
        <PanelBlock componentClasses={styles.cardsListContainer} thinPadding>
            <div className={styles.cardFolder}>
                <Title skin="h6" componentClasses={styles.chartTypesTitle}>
                    {title}
                </Title>
                <Flex {...flexWrapProps} componentClasses={styles.typeCardsWrapper}>
                    {chartTypeList.map(type => {
                        return (
                            <div key={type}>
                                <ChatBoxButton
                                    disabled={null}
                                    componentClasses={styles.chatboxItem}
                                    value={type}
                                    active={type === currentType}
                                    icon={ChartIcons[type]}
                                    onClick={() => handleChartButtonClick(type)}
                                    iconClassName={styles.largeIcon}
                                    tooltipProps={{
                                        position: 'bottom',
                                        tooltipOffset: 12,
                                        tooltip: (
                                            <>
                                                <Text skin="subtitle-2" tag="span">
                                                    {getChartLabelByType(type)} -{' '}
                                                </Text>
                                                <Text skin="paragraph-2" tag="span">
                                                    {getChartTooltipByType(type)}
                                                </Text>
                                            </>
                                        )
                                    }}
                                />
                            </div>
                        );
                    })}
                </Flex>
            </div>
        </PanelBlock>
    );
};

export default ChartTypesCard;
